import React from "react";
import "chart.js/auto";
import { Chart as ChartJS } from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Navbar from "../utils/Navbar";

ChartJS.register(ChartDataLabels);

const DashboardView = ({
  objekte,
  kategorien,
  ablageorte,
  typen,
  laender,
  materialien,
  waehrungen,
  zustaende,
  eigentuemer,
}) => {
  const countPerField = (fieldName) => {
    return objekte.reduce((acc, obj) => {
      const key = obj[fieldName] || "Unbekannt";
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});
  };

  const createNameMap = (array) =>
    Array.isArray(array)
      ? array.reduce((acc, item) => {
          acc[item.id] =
            item.name || `${item.vorname || ""} ${item.name || ""}`.trim();
          return acc;
        }, {})
      : {};

  const nameMaps = {
    kategorie: createNameMap(kategorien),
    ablageort: createNameMap(ablageorte),
    typ: createNameMap(typen),
    land: createNameMap(laender),
    material: createNameMap(materialien),
    waehrung: createNameMap(waehrungen),
    zustand: createNameMap(zustaende),
    eigentuemer: createNameMap(eigentuemer),
  };

  const fields = [
    { key: "kategorie", label: "Kategorie" },
    { key: "ablageort", label: "Ablageort" },
    { key: "typ", label: "Typ" },
    { key: "land", label: "Land" },
    { key: "material", label: "Material" },
    { key: "waehrung", label: "Währung" },
    { key: "zustand", label: "Zustand" },
    { key: "eigentuemer", label: "Eigentümer" },
  ];

  const renderChartCard = (fieldKey, fieldLabel) => {
    const TOP_N = 5;
    const fieldData = countPerField(fieldKey);

    const sortedEntries = Object.entries(fieldData)
      .sort(([, a], [, b]) => b - a)
      .slice(0, TOP_N);

    const labels = sortedEntries.map(
      ([id]) => nameMaps[fieldKey]?.[id] || `ID ${id}`
    );
    const values = sortedEntries.map(([, count]) => count);
    const total = values.reduce((sum, val) => sum + val, 0);

    const data = {
      labels,
      datasets: [
        {
          label: `Top ${TOP_N} ${fieldLabel}`,
          data: values,
          backgroundColor: labels.map(
            (_, i) => `hsl(${(i * 360) / labels.length}, 60%, 60%)`
          ),
        },
      ],
    };

    const options = {
      plugins: {
        datalabels: {
          color: "#333",
          formatter: (value) => `${((value / total) * 100).toFixed(1)}%`,
          font: {
            weight: "bold",
            size: 12,
          },
        },
        legend: {
          position: "bottom",
        },
      },
    };

    return (
      <div className="col-md-6 mb-4" key={fieldKey}>
        <div className="card h-100 shadow-sm p-3">
          <h5 className="text-center mb-3">{`Top ${TOP_N}: ${fieldLabel}`}</h5>
          <Pie data={data} options={options} />
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h3 className="mb-4">📊 Dashboard</h3>
        <div className="row">
          {fields.map(({ key, label }) => renderChartCard(key, label))}
        </div>
      </div>
    </>
  );
};

export default DashboardView;
